import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createStore, combineReducers, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';

import animalTypeReducer from './store/reducers/animalTypeReducer';
import breedReducer from './store/reducers/breedReducer';
import birthDateReducer from './store/reducers/birthDateReducer';
import genderReducer from './store/reducers/genderReducer';
import signalmentReducer from './store/reducers/signalmentReducer';
import weeksLitterReducer from './store/reducers/weeksLitterReducer';
import mainHeadingReducer from './store/reducers/mainHeadingReducer';
import bodyConditionReducer from './store/reducers/bodyConditionReducer';
import conditionScoreReducer from './store/reducers/conditionScoreReducer';
import weightAdjustmentReducer from './store/reducers/weightAdjustmentReducer';
import physicalActivityReducer from './store/reducers/physicalActivityReducer';
import diagnosesReducer from './store/reducers/diagnosesReducer';
import criticalCareReducer from './store/reducers/criticalCareReducer';
import idealBodyWeightReducer from './store/reducers/idealBodyWeightReducer';
import dailyIntakeReducer from './store/reducers/dailyIntakeReducer';
import dietReducer from './store/reducers/dietReducer';
import productsReducer from './store/reducers/productsReducer';
import feedingGuidelinesLineChartReducer from './store/reducers/feedingGuidelinesLineChartReducer';
import feedingGuidelinesFoodIntakeReducer from './store/reducers/feedingGuidelinesFoodIntakeReducer';
import feedingGuidelinesBodyConditionReducer from './store/reducers/feedingGuidelinesBodyConditionReducer';
import feedingGuidelinesPersonalizedNutrientProfileReducer from './store/reducers/feedingGuidelinesPersonalizedNutrientProfileReducer';
import feedingGuidelinesProductsReducer from './store/reducers/feedingGuidelinesProductsReducer';
import feedingGuidelinesNotesReducer from './store/reducers/feedingGuidelinesNotesReducer';
import feedingGuidelinesDisclaimerReducer from './store/reducers/feedingGuidelinesDisclaimerReducer';
import feedingGuidelinesHeaderReducer from './store/reducers/feedingGuidelinesHeaderReducer';
import feedingGuidelinesIntroReducer from './store/reducers/feedingGuidelinesIntroReducer';
import feedingGuidelinesRecommendedReducer from './store/reducers/feedingGuidelinesRecommendedReducer';
import feedingGuidelinesGenerateReducer from './store/reducers/feedingGuidelinesGenerateReducer';
import petInfoReducer from './store/reducers/petInfoReducer';
import appReducer from './store/reducers/appReducer';
import helpReducer from './store/reducers/helpReducer';
import calculateDerReducer from './store/reducers/calculateDerReducer';
import lifeStageMappingReducer from './store/reducers/lifeStageMappingReducer';
import pdfOutputReducer from './store/reducers/pdfOutputReducer';
import dailyWetReducer from './store/reducers/dailyWetReducer';
import feedingGuidelinesPrintReducer from './store/reducers/feedingGuidelinesPrintReducer';
import clearButtonReducer from './store/reducers/clearButtonReducer';

import App from './App';
import * as serviceWorker from './serviceWorker';

// Combine reducers
const rootReducer = combineReducers({
  animalTypeReducer: animalTypeReducer,
  breedReducer: breedReducer,
  birthDateReducer: birthDateReducer,
  genderReducer: genderReducer,
  signalmentReducer: signalmentReducer,
  weeksLitterReducer: weeksLitterReducer,
  mainHeadingReducer: mainHeadingReducer,
  bodyConditionReducer: bodyConditionReducer,
  conditionScoreReducer: conditionScoreReducer,
  weightAdjustmentReducer: weightAdjustmentReducer,
  physicalActivityReducer: physicalActivityReducer,
  diagnosesReducer: diagnosesReducer,
  criticalCareReducer: criticalCareReducer,
  idealBodyWeightReducer: idealBodyWeightReducer,
  dailyIntakeReducer: dailyIntakeReducer,
  dietReducer: dietReducer,
  productsReducer: productsReducer,
  feedingGuidelinesLineChartReducer: feedingGuidelinesLineChartReducer,
  feedingGuidelinesFoodIntakeReducer: feedingGuidelinesFoodIntakeReducer,
  feedingGuidelinesBodyConditionReducer: feedingGuidelinesBodyConditionReducer,
  feedingGuidelinesPersonalizedNutrientProfileReducer: feedingGuidelinesPersonalizedNutrientProfileReducer,
  feedingGuidelinesProductsReducer: feedingGuidelinesProductsReducer,
  feedingGuidelinesNotesReducer: feedingGuidelinesNotesReducer,
  feedingGuidelinesDisclaimerReducer: feedingGuidelinesDisclaimerReducer,
  feedingGuidelinesHeaderReducer: feedingGuidelinesHeaderReducer,
  feedingGuidelinesIntroReducer: feedingGuidelinesIntroReducer,
  feedingGuidelinesRecommendedReducer: feedingGuidelinesRecommendedReducer,
  feedingGuidelinesGenerateReducer: feedingGuidelinesGenerateReducer,
  petInfoReducer: petInfoReducer,
  appReducer: appReducer,
  helpReducer: helpReducer,
  calculateDerReducer: calculateDerReducer,
  lifeStageMappingReducer: lifeStageMappingReducer,
  dailyWetReducer: dailyWetReducer,
  pdfOutputReducer: pdfOutputReducer,
  feedingGuidelinesPrintReducer: feedingGuidelinesPrintReducer,
  clearButtonReducer: clearButtonReducer,
});
// Create Redux store
const store = createStore(rootReducer, applyMiddleware(thunk));

ReactDOM.render(<Provider store={store}><App /></Provider>, document.getElementById('nppe2-feeding-calc-react-app'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
